import React, { useState } from 'react'
import { styled } from '@mui/material/styles'
import Button from '@mui/material/Button'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { EXPORT_TYPES } from 'src/clinic/views/clinicBrandPayoutReports/util'

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color: 'rgb(55, 65, 81)',
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
    },
  },
}))

export default function ExportTypeSelector({
  handleSelectExportType,
  emailLabel,
  hideOptionsId = [],
  mainButton = ({ handleClick, isOpen = false }) => {
    return (
      <Button
        id="export-type-button"
        aria-controls={isOpen ? 'export-type-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={isOpen ? 'true' : undefined}
        variant="contained"
        disableElevation
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
      >
        Export
      </Button>
    )
  },
}) {
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleSelectType = (exportType) => {
    // Blur the active element to remove focus before closing menu
    if (document.activeElement) {
      document.activeElement.blur()
    }
    // Close menu first to avoid aria-hidden warning
    handleClose()
    // Use setTimeout to ensure menu is fully closed before triggering action
    setTimeout(() => {
      if (handleSelectExportType) {
        handleSelectExportType(exportType.id)
      }
    }, 100)
  }

  return (
    <div>
      {mainButton({ handleClick, isOpen: open })}

      <StyledMenu
        id="export-type-menu"
        slotProps={{
          list: {
            'aria-labelledby': 'export-type-button',
          },
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {Object.values(EXPORT_TYPES)
          .filter((exportType) => !hideOptionsId.includes(exportType.id))
          .map((exportType) => {
            let label = exportType.label
            if (exportType.id === EXPORT_TYPES.email_pdf.id && emailLabel) {
              label = emailLabel
            }
            return (
              <MenuItem
                key={exportType.id}
                onClick={() => handleSelectType(exportType)}
                disableRipple
              >
                <exportType.icon />
                {label}
              </MenuItem>
            )
          })}
      </StyledMenu>
    </div>
  )
}
